export const SimsCategoryHomePageData = [
  {
    id: 1,
    title: "فیزیک",
    img: require("../../../image/home/category/physics.svg"),
    alt: "دسته فیزیک",
    path: "sims?filter_subject__id__in=1",
  },
  {
    id: 2,
    title: "ریاضی",
    img: require("../../../image/home/category/math.svg"),
    alt: "دسته ریاضی",
    path: "sims?filter_subject__id__in=2",
  },
  {
    id: 3,
    title: "شیمی",
    img: require("../../../image/home/category/chemistry.svg"),
    alt: "دسته شیمی",
    path: "sims?filter_subject__id__in=3",
  },
  {
    id: 4,
    title: "زیست",
    img: require("../../../image/home/category/biology.svg"),
    alt: "دسته زیست",
    path: "sims?filter_subject__id__in=4",
  },
];
